import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "detail-item" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "Student Time Commitment: ", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Purpose:", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = {
  key: 1,
  class: "detail-item"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Description:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_planner_event_card = _resolveComponent("planner-event-card")!

  return (_openBlock(), _createBlock(_component_planner_event_card, { event: _ctx.calendarEvent }, {
    dates: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_ctx.startDate) + "–" + _toDisplayString(_ctx.endDate), 1)
    ]),
    description: _withCtx(() => [
      (_ctx.isAssignmentEvent(_ctx.eventType))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("p", null, [
                _hoisted_2,
                _createTextVNode(" " + _toDisplayString(_ctx.eventType.timeCommitment.time || "Not Available") + " ", 1),
                (_ctx.eventType.timeCommitment.comment)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(_ctx.eventType.timeCommitment.comment) + ")", 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", null, [
                _hoisted_5,
                _hoisted_6,
                _createTextVNode(" " + _toDisplayString(_ctx.eventType.purpose || "Not Available"), 1)
              ])
            ])
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("p", null, [
              _hoisted_8,
              _hoisted_9,
              _createTextVNode(" " + _toDisplayString(_ctx.eventType.description || "Not Available"), 1)
            ])
          ]))
    ]),
    _: 1
  }, 8, ["event"]))
}